import { render, staticRenderFns } from "./ReportClientIndividualChart.vue?vue&type=template&id=4ca650e2&scoped=true&"
import script from "./ReportClientIndividualChart.vue?vue&type=script&lang=ts&"
export * from "./ReportClientIndividualChart.vue?vue&type=script&lang=ts&"
import style0 from "./ReportClientIndividualChart.vue?vue&type=style&index=0&id=4ca650e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca650e2",
  null
  
)

export default component.exports